import { useContext, useEffect, useMemo, useState } from "react";


import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useGetAllEstablishments } from "../api/getAllEstablishments";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";

// All your logic is here
export const useEstablishmentsDataViewLogic = () => {
  const { activeFilters } = useContext(SydFilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: []});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetEstablishment["data"]>([]);
  const getAllEstablishmentsQuery = useGetAllEstablishments({data: activeFilters as IEstablishmentSearchForm});
  const { t } = useTranslation();

  const loadingDone = [getAllEstablishmentsQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getAllEstablishmentsQuery].filter(({ isError }) => isError ? true : false);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getAllEstablishmentsQuery.data ? getAllEstablishmentsQuery.data.data : [];
  const apiTotalRecords = getAllEstablishmentsQuery.data ? getAllEstablishmentsQuery.data.totalRercords : 0;

  const columnData = [
    {
      columnName: "id",
      columnDisplayName: "ID",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "description",
      columnDisplayName: "Ονομασία",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "unID",
      columnDisplayName: "Κωδικός",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "deleted",
      columnDisplayName: "Διαγραμμένο",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "Boolean",
    }
  ]

  const columns = useMemo(() => {
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Καταστήματος");
        break;
      case "edit":
        title = t("Επεξεργασία Καταστήματος");
        break;
      case "delete":
        title = t("Διαγραφή Καταστήματος");
        break;
      case "showDetails":
        title = t("Λεπτομέρειες");
        break; 
      default:
        break;
    }
    return title;
  };

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable && selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };

  useEffect(() => {
    setSelectedRowsOfTable([]);
    getAllEstablishmentsQuery.refetch();
  }, [activeFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    apiTotalRecords
  }
};
